module.exports = __webpack_public_path__ + "static/media/Badge_SvgExpertCategoriel_Pediatrie.90c9829e.png";